var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Flex } from 'rebass';
import { media } from '../media';
import styled, { remCalc } from '../styled-components';
export var Item = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-direction: column;\n  flex-wrap: wrap;\n  ", "\n"], ["\n  flex-direction: column;\n  flex-wrap: wrap;\n  ", "\n"])), media.minSm(templateObject_1 || (templateObject_1 = __makeTemplateObject(["flex-direction: row; & + & { margin-left: ", "; }"], ["flex-direction: row; & + & { margin-left: ", "; }"])), remCalc(8)));
var templateObject_1, templateObject_2;
